import React from 'react';
import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import './styles.scss';
type DeleteModalType = 'archive' | 'delete';
type DeleteModalColorType = 'red' | 'none';
const DeleteModal = ({
  type = 'delete',
  show,
  onClose,
  handleDelete,
  title,
  description,
  loading,
  emoji = '😓',
  color = 'none'
}: {
  type?: DeleteModalType;
  show: boolean;
  onClose: (refetchData?: boolean) => void;
  handleDelete: () => void;
  title: string;
  description: string;
  loading?: boolean;
  emoji?: string;
  color?: DeleteModalColorType;
}) => {
  return (
    <div className='bg-red-4 delete-modal'>
      <BaseModal
        isOpen={show}
        title=''
        hideHeader
        titleIcon={<AddIcon />}
        titleIconColor='gray'
        onRequestClose={() => onClose()}
        footer={
          <div className='flex gap-4 items-center'>
            <Button onClick={() => onClose()} color='gray' variant='block' small>
              Cancel
            </Button>
            <Button onClick={handleDelete} color='primary' variant='block' loading={loading} small>
              {type === 'archive' ? 'Archive' : 'Delete'}
            </Button>
          </div>
        }>
        <div className='flex flex-col items-center pt-6'>
          <div className={`mt-4 ${color == 'red' && 'archive-modal__secondlayer'}`}>
            <div className={`${color == 'red' && 'archive-modal__firstlayer'}`}>
              <p className={`${color == 'red' && 'archive-modal__emoji'}`}>{emoji}</p>
            </div>
          </div>

          <h4>
            <strong>{title}</strong>
          </h4>
          <p className='text-sm text-gray-5 max-w-52 text-center'>{description}</p>
        </div>
      </BaseModal>
    </div>
  );
};

export default DeleteModal;
